export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "How can I start a project with Dev Cubix?",
    answer: "Starting a project with us is simple. Just reach out through our contact form or email at info@devcubix.com, and share a brief about your needs. We'll schedule a call to understand your goals, discuss the scope, and recommend the right approach tailored to your product or brand.",
  },
  {
    question: "Is Dev Cubix a start-up-friendly agency?",
    answer: "Yes! We understand the unique challenges start-ups face and offer affordable, flexible solutions that fit your budget. Our team is committed to helping your start-up build a strong brand and digital presence from the ground up.",
  },
  {
    question: "Why is Dev Cubix different?",
    answer: "We combine full-stack development expertise with design thinking. Our team delivers high-quality work across web development, mobile apps, UI/UX, and graphic design. Plus, we're available 24/7 and offer unlimited revisions.",
  },
  {
    question: "How long does a project take?",
    answer: "Timelines depend on scope. A standard website takes 2-4 weeks, a mobile app 4-8 weeks, and a full brand identity 1-2 weeks. We'll give you a clear timeline during our initial consultation.",
  },
  {
    question: "What tools and technologies do you use?",
    answer: "For development: React, Node.js, WordPress, Flutter, Figma. For design: Adobe Creative Suite, Figma, FigJam. For project management: Notion, Slack, Trello. We pick the best tools for each project.",
  },
  {
    question: "Do you provide maintenance after launch?",
    answer: "Yes! We offer lifetime support and maintenance. Whether your product needs updates, bug fixes, or new features, we're here for you long after launch.",
  },
];
